// removed by extract-text-webpack-plugin
module.exports = {"headingLarge":"_2wRVZPFV8yHNOSjn","headingMedium":"_3_gtZKmQC8E5rxzu","headingSmall":"_3Gj5NFDonHBM3s0o","paragraph":"_1NWiUTn1MKBisFvg","approve":"UnyqFPTRnLBWU9Dm","fontMedium":"_2Ej54rTcHtp0ZJpX","faded":"XJwwNN2Tx0Cnnoqm"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Markup.pcss
// module id = 472
// module chunks = 1